export interface DayData {
  key: string
  totalRevenue: number
  totalSubscriptionsRevenue: number
  totalPurchases: number
  newSubscriptionsRevenue: number
  recurringSubscriptionsRevenue: number
  messageRevenue: number
  tipsRevenue: number
  postsRevenue: number
  streamRevenue: number
  newSubscriptions: number
  linkClicks: number
  openChatCount: number
  sellingChatCount: number
  averageFanSpend: number
  spendingFansCount: number
}

export const WEEK_DAYS = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
] as const
type BestDay = Record<(typeof WEEK_DAYS)[number], number>

interface BestHour {
  [hour: string]: number
}

export type Weekday =
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | 'SUNDAY'
export interface StatisticsByHours {
  [hour: string]: number
}

export interface StatisticsData {
  timezoneOffset: string
  data: {
    [date: string]: DayData
  }
  total: {
    totalRevenue: number
    totalSubscriptionsRevenue: number
    totalPurchases: number
    newSubscriptionsRevenue: number
    recurringSubscriptionsRevenue: number
    messageRevenue: number
    tipsRevenue: number
    postsRevenue: number
    streamRevenue: number
    newSubscriptions: number
    linkClicks: number
    openChatCount: number
    sellingChatCount: number
    spendingFansCount: number
    averageFanSpend: number
  }
  lastTotal: {
    totalRevenue: number | null
    totalSubscriptionsRevenue: number | null
    totalPurchases: number | null
    newSubscriptionsRevenue: number | null
    recurringSubscriptionsRevenue: number | null
    messageRevenue: number | null
    tipsRevenue: number | null
    postsRevenue: number | null
    streamRevenue: number | null
    newSubscriptions: number | null
    linkClicks: number | null
    openChatCount: number | null
    sellingChatCount: number | null
    spendingFansCount: number | null
    averageFanSpend: number | null
  }
  bestDay: BestDay
  bestHour: BestHour
  earningsHeatmap: Record<Weekday, StatisticsByHours>
  fanActivityHeatmap: Record<Weekday, StatisticsByHours>
}

export interface DetailedComparisonType {
  averageFanSpend: number
  creatorId: number
  creator: string
  creatorUserName: string
  creatorProfilePicture?: string | null
  totalRevenue: number
  newSubs: number
  newSubscriptionsRevenue: number
  recurringSubscriptionsRevenue: number
  totalSubscriptionsRevenue: number
  tipsRevenue: number
  messageRevenue: number
  textingRatio: number | string
  linkClicks: number
  openChats: number | string
  sellingChats: number | string
  conversionRate: number | string
  spendingFansCount: number
}

export interface CategoryChartType {
  title: string
  tooltip: string
  value: number
  color: string
  icon: React.ReactElement
  onChange: (value: number) => void
  testId?: string
}

export interface CreatorFanStats {
  name: string
  username: string
  avatar: null | string
  purchases: number
  totalSpend: number
}
